import { render } from "./navbar.vue?vue&type=template&id=056a96c6"
import script from "./navbar.vue?vue&type=script&lang=ts"
export * from "./navbar.vue?vue&type=script&lang=ts"
script.render = render

export default script